import React, { useEffect, useState } from "react";

import Main from "../layout/Main"
const NoAccess = () => {
  return <>You Dont's Have Permission</>;
};
export default NoAccess;
